import { render, staticRenderFns } from "./demandList.vue?vue&type=template&id=7aafcd16&scoped=true"
import script from "./demandList.vue?vue&type=script&lang=js"
export * from "./demandList.vue?vue&type=script&lang=js"
import style0 from "./demandList.vue?vue&type=style&index=0&id=7aafcd16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aafcd16",
  null
  
)

export default component.exports